import { UserPermissions } from "Infrastructure/Api/permissions";
import { PermissionGuard } from "Infrastructure/Components/PermissionGuard";
import { InvoiceListPage } from "Order/Modules/Invoice/Pages";
import { InvoicePaths } from "Order/Modules/Invoice/Routes/Routing";

export const InvoiceRoutes = [
	{
		path: InvoicePaths.List.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.InvoiceModule.read}>
				<InvoiceListPage />
			</PermissionGuard>
		),
	},
];
